export default {
    WAPI_URL: 'https://cta.vilpower.in', // 'http://localhost:8081/'
    DEFAULT_DOMAIN: 'vil.ltd',
    DEFAULT_DOMAIN_PUBLIC_IP: '206.1.30.150',
    DONUT_CHART_COLORS: ['#5F004B', '#2F3043', '#FFC600', '#EE2737', '#B6DCF3', '#4B994E'],
    PRIMARY_TEXT_COLOR: '#FFC600',
    CTATYPE_PIE_CHART_COLORS: ['#FFC600', '#EE2737', '#5F004B'],
    CLICKMETRICS_PIE_CHART_COLORS: ['#FFC600', '#5F004B'],
    REGISTERED_DLT: 'VIL'
}
